/**
 * Resuming an Adyen payment after the page itself navigated away: a Drop-in redirect (issuer-forced
 * 3DS redirect) or the hosted page opened in the same tab because the browser blocked the popup.
 *
 * The record lives in localStorage, not sessionStorage: a return that lands in a new tab (mobile
 * browsers, banking apps) starts with an empty sessionStorage. It is keyed per partner AND widget so
 * two widgets on one site never resume each other's payment.
 */
export const ADYEN_RESUME = {
  /** Record schema version; a record written by another shape is ignored, never half-read. */
  VERSION: 1,
  /** Storage key prefix, followed by `<partnerUuid>_<widgetUuid>`. Not a `sw_booking_` prefix on purpose: `refresh=1` must not wipe a payment in flight. */
  STORAGE_KEY_PREFIX: 'sw_adyen_resume_',
  /** Same lifetime as a hosted session (25 minutes); an older record describes a session Adyen no longer settles. */
  TTL_MS: 25 * 60 * 1000,
  KIND: {
    DROPIN: 'dropin',
    HOSTED: 'hosted',
  },
  /** Query parameters a return brings with it. All are removed from the address bar on load. */
  RETURN_PARAMS: {
    REDIRECT_RESULT: 'redirectResult',
    SESSION_ID: 'sessionId',
    HOSTED_NONCE: 'adyen_hosted',
  },
  I18N: {
    CHECKING: 'adyen.resume.checking',
    CONTEXT_CHANGED: 'adyen.errors.context_changed',
    ALREADY_BOOKED: 'adyen.errors.already_booked',
  },
} as const;
